<template lang="pug">
  .modal-overlay(v-if="isOpen" @click="closeModal")
    .modal-content(@click.stop)
      button.close-btn(@click="closeModal") X
      h3 {{ titulo }}
        Mapa.mapa-container(
        v-if="dadosMonitoramento && dadosMonitoramento.numeroDoCAR"
        ref='mapa',
        :area='dadosMonitoramento.nomeArea',
        :codigoImovel='dadosMonitoramento.numeroDoCAR',
        @layerAtualUpdated='layerAtualMapa = $event'
        @loaded='desenharPoligonos'
        )

        
</template>

<script>
import Mapa from '@/components/Mapa/Mapa.vue';

export default {
    name: 'MonitoramentoModal',
    components: { Mapa },
    props: {
        isOpen: Boolean,
        titulo: String,
        dadosMonitoramento: Object,
    },
    data() {
        return {
            layerAtualMapa: null,
            areaVetorizada: 0,
        };
    },
    methods: {
        desenharPoligonos() {
            if (!this.dadosMonitoramento) {
                console.warn('❌ Nenhum dado de monitoramento disponível.');
                return;
            }

            const parcelas = Array.isArray(this.dadosMonitoramento.etapasFotoParcela)
                ? this.dadosMonitoramento.etapasFotoParcela
                : [];

            parcelas.forEach((parcela) => {
                const anexos = Array.isArray(parcela.anexos) ? parcela.anexos : [];

                anexos.forEach((anexo) => {
                    const geometry = anexo.coordenadas || null;
                    const centro = anexo.geolocalizacao || null;

                    if (geometry && geometry.coordinates && centro) {
                        const coordenadasValidadas = this.validarCoordenadasPolygon(geometry.coordinates[0]);

                        if (!coordenadasValidadas || coordenadasValidadas.length < 3) {
                            console.error('Coordenadas do polígono inválidas:', geometry.coordinates[0]);
                            return;
                        }

                        const latLngs = coordenadasValidadas.map((coord) => [coord[1], coord[0]]);
                        const centroCorrigido = [centro.latitude, centro.longitude];

                        this.$refs.mapa.desenharPoligonoFixado(latLngs, centroCorrigido);
                    } else {
                        console.warn('🔍 Anexo sem coordenadas válidas ou centro:', anexo);
                    }
                });
            });
        },
        validarCoordenadasPolygon(coordenadas) {
            if (Array.isArray(coordenadas) && coordenadas.length > 0) {
                const coordenadasValidas = coordenadas
                    .map((coord) => {
                        if (Array.isArray(coord) && coord.length === 2 && !isNaN(coord[0]) && !isNaN(coord[1])) {
                            return coord;
                        } else {
                            console.error('Coordenada inválida:', coord);
                            return null;
                        }
                    })
                    .filter((coord) => coord !== null);

                return coordenadasValidas.length === coordenadas.length ? coordenadasValidas : null;
            }
            return null;
        },
        closeModal() {
            this.$emit('close-modal');
        },
    },
};
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}

.modal-content {
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    max-width: 600px;
    width: 100%;
    text-align: center;
    position: relative;
}

.close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
}
</style>
